const BASE62 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
// export const idToSlug = (_id) => {
//     const hex = _id.replace(/-/g, '');
//     if (hex.length !== 24) throw new Error('Invalid _id length');

//     // Process in 6-character chunks to avoid number size issues
//     const chunks = [
//         parseInt(hex.substring(0, 6), 16),
//         parseInt(hex.substring(6, 12), 16),
//         parseInt(hex.substring(12, 18), 16),
//         parseInt(hex.substring(18), 16)
//     ];

//     return chunks.map(num => {
//         let slug = '';
//         do {
//             slug = BASE62[num % 62] + slug;
//             num = Math.floor(num / 62);
//         } while (num > 0);
//         return slug;
//     }).join('');
// };

// export const slugToId = (slug) => {
//     // Split slug into 4 roughly equal parts
//     const chunkSize = Math.ceil(slug.length / 4);
//     const chunks = [];
//     for (let i = 0; i < slug.length; i += chunkSize) {
//         chunks.push(slug.substring(i, i + chunkSize));
//     }

//     return chunks.map(chunk => {
//         let num = 0;
//         for (const char of chunk) {
//             const index = BASE62.indexOf(char);
//             if (index === -1) throw new Error('Invalid slug character');
//             num = num * 62 + index;
//         }
//         return num.toString(16).padStart(6, '0');
//     }).join('');
// };

// export const slugToId = (slug) => {
//     let num = 0;
//     for (const char of slug) {
//         const index = BASE62.indexOf(char);
//         if (index === -1) throw new Error('Invalid slug character');
//         num = num * 62 + index;
//     }
//     // Return without padding zeros
//     return num.toString(16);
// };

// export const slugToId = (slug) => {
//     // Calculate chunk size (we split into 4 parts)
//     const chunkSize = Math.ceil(slug.length / 4);
//     const chunks = [];

//     // Split the slug into 4 parts
//     for (let i = 0; i < slug.length; i += chunkSize) {
//         chunks.push(slug.substring(i, Math.min(i + chunkSize, slug.length)));
//     }

//     // Process each chunk
//     const hexParts = chunks.map(chunk => {
//         let num = 0;
//         for (const char of chunk) {
//             const index = BASE62.indexOf(char);
//             if (index === -1) throw new Error(`Invalid character in slug: ${char}`);
//             num = num * 62 + index;
//         }
//         return num.toString(16).padStart(6, '0');
//     });

//     // Combine and ensure exactly 24 characters
//     const hexId = hexParts.join('');
//     if (hexId.length !== 24) {
//         throw new Error(`Decoded ID length mismatch: expected 24, got ${hexId.length}`);
//     }

//     return hexId;
// };

// export const idToSlug = (_id) => {
//     const hex = _id.replace(/-/g, '');
//     if (hex.length !== 24) throw new Error('Invalid _id length');

//     // Convert hex string to BigInt
//     const num = BigInt('0x' + hex);

//     // Base62 encoding
//     let slug = '';
//     let n = num;
//     const base = 62n;

//     do {
//         slug = BASE62[Number(n % base)] + slug;
//         n = n / base;
//     } while (n > 0n);

//     return slug;
// };

// export const slugToId = (slug) => {
//     let num = 0n;
//     const base = 62n;

//     for (const char of slug) {
//         const index = BigInt(BASE62.indexOf(char));
//         if (index === -1n) throw new Error('Invalid slug character');
//         num = num * base + index;
//     }

//     // Convert back to 24-character hex, preserving leading zeros
//     const hex = num.toString(16).padStart(24, '0');

//     // Final validation
//     if (hex.length !== 24) {
//         throw new Error(`Invalid ID length after decoding: ${hex.length}`);
//     }

//     return hex;
// };


export const idToSlug = (_id) => {
    const hex = _id.replace(/-/g, '');
    if (hex.length !== 24) throw new Error('Invalid _id length');

    // Split into three 8-character parts
    const parts = [
        parseInt(hex.substring(0, 8), 16),
        parseInt(hex.substring(8, 16), 16),
        parseInt(hex.substring(16), 16)
    ];

    return parts.map(num => {
        let slug = '';
        do {
            slug = BASE62[num % 62] + slug;
            num = Math.floor(num / 62);
        } while (num > 0);
        return slug;
    }).join('-');
};

// Handles both old and new slug formats
export const slugToId = (slug) => {
    // Try three-part format first (new version)
    if (slug.includes('-')) {
        const parts = slug.split('-');
        if (parts.length !== 3) throw new Error('Invalid slug format');

        return parts.map(part => {
            let num = 0;
            for (const char of part) {
                const index = BASE62.indexOf(char);
                if (index === -1) throw new Error('Invalid slug character');
                num = num * 62 + index;
            }
            return num.toString(16).padStart(8, '0');
        }).join('');
    }

    // Fallback to old single-part format
    let num = 0;
    for (const char of slug) {
        const index = BASE62.indexOf(char);
        if (index === -1) throw new Error('Invalid slug character');
        num = num * 62 + index;
    }
    return num.toString(16).padStart(24, '0');
};
/* global BigInt */
// 🔹 Convert hex → Base62
function hexToBase62(hex) {
  let num = BigInt("0x" + hex);
  let str = "";

  while (num > 0n) {
    const rem = Number(num % 62n);
    str = BASE62[rem] + str;
    num = num / 62n;
  }

  return str;
}

// 🔹 Convert Base62 → hex (FULL 24 hex)
function base62ToHex(str) {
  let num = 0n;

  for (const char of str) {
    const index = BASE62.indexOf(char);
    if (index === -1) {
      throw new Error("Invalid slug character");
    }
    num = num * 62n + BigInt(index);
  }

  return num.toString(16).padStart(24, "0"); // ✅ FULL 24
}


// ✅ Generate slug (_id required, gymId optional)
export function generateSlug(_id, gymId) {
  const idHex = _id.replace(/-/g, "");

  if (idHex.length !== 24) {
    throw new Error("Invalid _id");
  }

  const idPart = hexToBase62(idHex); // ✅ FULL ID

  if (!gymId) {
    return idPart;
  }

  const gymHex = gymId.replace(/-/g, "");

  if (gymHex.length !== 24) {
    throw new Error("Invalid gymId");
  }

  const gymPart = hexToBase62(gymHex); // ✅ FULL

  return `${idPart}-${gymPart}`;
}


// ✅ Decode slug
export function decodeSlug(slug) {
  const parts = slug.split("-");

  // Only _id
  if (parts.length === 1) {
    return {
      classId: base62ToHex(parts[0], 12),
    };
  }

  // _id + gymId
  if (parts.length === 2) {
    return {
      classId: base62ToHex(parts[0], 12),
      schedId: base62ToHex(parts[1], 12),
    };
  }

  throw new Error("Invalid slug format");
}